// extracted by mini-css-extract-plugin
export default {"productGallery":"sG-z","inQuickShop":"tG-z"};